import Render from '@Views/components/spinner.html'
import { Vue, Component } from 'vue-property-decorator'

@Render
@Component({})
export class Spinner extends Vue {
}